<template>
  <v-row>
    <v-col cols="12"  class="historic-quotation__container">
      <v-row class="pa-5">
        <v-col cols="12" sm="9" class="align-self-center px-4">
          <div class="font-weight-bold mb-0 primary--text">
           {{ item.insurer }} - {{ formattedDate }} <br/> {{ item.method }} - {{ item.endpoint }}
          </div>          
        </v-col>
        <v-col cols="12" sm="3" class="px-4 d-flex justify-end">
          <span class="align-self-center px-4">
            STATUS {{ item.code }}
            <v-icon
              :color="item.code >= 400 ? 'red' : 'green'"
              size="20"
              class="iconStatus pl-3 mb-1"
              >
              fa fa-circle
            </v-icon>
          </span>
          <BaseButton icon :disabled="!hasAny" @click="showItem()" class="align-self-center">
            <v-icon color="primary" size="14"> {{ iconShowItem }} </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <v-row class="px-5 pb-3" v-if="visibleItem">
        <v-col cols="12">
          <div class="pb-2">
            <v-row class="white py-5 px-4 mb-5" v-if="hasPayload">
              <v-col
                cols="12"
                sm="2"
                class="justify-center d-flex justify-sm-start"
                >
                <span class="primary--text font-weight-bold body-1 mb-sm-0">
                  payload enviado: 
                </span>
              </v-col> 
              <v-col
                cols="12"
                sm="10"
                class="justify-center d-flex justify-sm-start"
                >
                <p class="primary--text mb-sm-0 pl-3">
                   {{ item.payload }}
                </p>
              </v-col>                
            </v-row>
            
            <v-row class="white py-5 px-4 mb-5"  v-if="hasResponse">
              <v-col
                cols="12"
                sm="2"
                class="justify-center d-flex justify-sm-start"
              >
                <span class="primary--text font-weight-bold body-1 mb-sm-0">
                resposta: 
                </span>
              </v-col>   
              <v-col
                cols="12"
                sm="10"
                class="justify-center d-flex justify-sm-start"
              >
                <p class="primary--text mb-sm-0 pl-3">
                   {{ item.response }}
                </p>
              </v-col>              
            </v-row>
          
            <v-row class="white py-5 px-4 mb-5" v-if="hasError">
              <v-col
                cols="12"
                sm="2"
                class="justify-center d-flex justify-sm-start"
              >
                <span class="primary--text font-weight-bold body-1 mb-sm-0">
                mensagem de erro: 
                </span>
              </v-col> 
              <v-col
                cols="12"
                sm="10"
                class="justify-center d-flex justify-sm-start"
              >
                <p class="primary--text mb-sm-0 pl-3">
                   {{ item.error }}
                </p>
              </v-col>               
            </v-row>
           
            <v-row v-if="hasAny">
              <v-col
                cols="12"
                sm="12"
                class="d-flex justify-end "
              >
              <BaseButton class="secondary justify-center-end px-4 pl-4" @click="copyText()">
                  <v-icon
                  color="grayscale"
                  size="20"
                  v-on="on"
                  class="pr-2"
                  >
                  fa-thin fa-copy
                  </v-icon>  COPIAR DADOS
              </BaseButton >
              </v-col> 
            </v-row>
          </div>
        </v-col>
      </v-row>
      <div class="historic-quotation__button" v-else />
    </v-col>
  </v-row>
</template>
<script>
import { formatHistoricDate } from "@/utils/formats.js";
import { mapActions } from "vuex";
export default {
  data: () => ({
    visibleItem: false,
    formatHistoricDate
  }),
  computed: {
    formattedDate() {
      let result = new Date(this.item.date);
      result.setHours(result.getHours() + 3);

      return formatHistoricDate(result);
    },
    iconShowItem() {
      return this.visibleItem ? "fa-chevron-up" : "fa-chevron-down";
    },
    hasPayload() {
      return this.item.payload && this.item.payload.length > 0;
    },
    hasResponse() {
      return this.item.response && this.item.response.length > 0;
    },
    hasError() {
      return this.item.error && this.item.error.length > 0;
    },
    hasAny() {
      return this.hasPayload || this.hasResponse || this.hasError;
    }
  },
  methods: {
  ...mapActions(["showAlertNotification"]),
    showItem() {
      this.visibleItem = !this.visibleItem;
    },
    copyText() {
      let text = `${this.item.insurer.toUpperCase()} - ${formatHistoricDate(this.item.date)}\nCHAMADA ${this.item.method} - ${this.item.endpoint}\n`;

      if(this.hasPayload) {
        text += `PAYLOAD ENVIO - ${this.item.payload}\n`;
      }

      text += `PAYLOAD RESPOSTA - ${this.item.response}`;
      
      navigator.clipboard.writeText(text);

      this.showAlertNotification({
        message: "Dados copiados para a área de transferência.",
        type: "info"
      });
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style lang="sass" scoped>
.historic-quotation__
  &container
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
    word-break: break-all
  &button
    min-width: 40px !important

.icon
  display: flex
  justify-content: flex-end
  background-color: #BDBBBB
  padding-top: 10px
  padding-right: 10px
  padding-bottom: 10px
  color: white 
  opacity:0.6
</style>
